<template>
    <base-select-filter
        v-if="roles.length"

        :value="value"
        v-bind="$attrs"
        :options="roles"

        option-label="name"
        option-value="id"
        @input="inputValue => $emit('input', inputValue)"
    >
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </base-select-filter>
</template>

<script>
import BaseSelectFilter from '@/components/form/BaseSelectFilter'
import { UserService } from '@/services'

export default {
    name: 'RoleSelect',
    components: {
        BaseSelectFilter,
    },
    inheritAttrs: false,
    props: {
        value: {
            required: true,
        },
    },
    data () {
        return {
            roles: [],
        }
    },
    created () {
        UserService.getRoles().then(response => {
            this.roles = response.data
        })
    },
}
</script>
